import React, { /* useState, */ useCallback } from 'react';
import { Box } from '@mui/material';
import { MessageProps } from '../../../types/chat';
import TextMessage from '../../atoms/chat/TextMessage';
import ReplyMessage from '../../atoms/chat/ReplyMessage';
import ImageMessage from '../../atoms/chat/ImageMessage';
import VideoMessage from '../../atoms/chat/VideoMessage';
import AudioMessage from '../../atoms/chat/AudioMessage';
import FileMessage from '../../atoms/chat/FileMessage';

const MessageItem: React.FC<MessageProps> = React.memo(({
  message,
  isCurrentUser,
  previousMessage,
  nextMessage,
  showUserInfo,
  onLongPress,
  onImagePress,
  onReactionPress,
  onReplyPress,
  onDeletePress,
  currentUserId,
  currentUserType
}) => {
  // TODO: Implement context menu functionality
  // const [contextMenuAnchor, setContextMenuAnchor] = useState<HTMLElement | null>(null);

  // Handle right-click context menu (desktop-specific) - TODO: Implement
  const handleContextMenu = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    // setContextMenuAnchor(event.currentTarget); // TODO: Uncomment when implementing context menu
    onLongPress?.(message);
  }, [message, onLongPress]);

  // Handle click for mobile-style long press simulation
  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    // For now, just handle normal clicks
    if (event.detail === 2) { // Double click
      onLongPress?.(message);
    }
  }, [message, onLongPress]);

  // Message grouping logic (same as mobile) - TODO: Use when implementing visual grouping
  // const shouldGroupWithPrevious = useCallback(() => {
  //   if (!previousMessage) return false;
  //   
  //   const timeDiff = Math.abs(
  //     new Date(message.createdOn).getTime() - 
  //     new Date(previousMessage.createdOn).getTime()
  //   );
  //   
  //   return message.fromUID === previousMessage.fromUID && timeDiff < 300000; // 5 minutes
  // }, [message, previousMessage]);

  // Render the appropriate message type component
  const renderMessageContent = () => {
    const baseProps = {
      message,
      isCurrentUser,
      previousMessage,
      nextMessage,
      showUserInfo,
      onLongPress,
      onImagePress,
      onReactionPress,
      onReplyPress,
      onDeletePress,
      currentUserId,
      currentUserType
    };

    switch (message.messageType) {
      case 'text':
        return <TextMessage {...baseProps} />;
      
      case 'reply':
        return <ReplyMessage {...baseProps} />;
      
      case 'image':
        return <ImageMessage {...baseProps} />;
      
      case 'video':
        return <VideoMessage {...baseProps} />;
      
      case 'audio':
        return <AudioMessage {...baseProps} />;
      
      case 'file':
      case 'pdf':
        return <FileMessage {...baseProps} />;
      
      default:
        // Fallback to text message
        return <TextMessage {...baseProps} />;
    }
  };

  return (
    <Box
      onContextMenu={handleContextMenu}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
        borderRadius: 1,
        transition: 'background-color 0.15s ease',
      }}
    >
      {renderMessageContent()}
      
      {/* TODO: Add MessageContextMenu component */}
      {/* <MessageContextMenu
        message={message}
        anchorEl={contextMenuAnchor}
        onClose={() => setContextMenuAnchor(null)}
        onAction={handleContextAction}
        currentUserId={currentUserId}
      /> */}
    </Box>
  );
});

MessageItem.displayName = 'MessageItem';

export default MessageItem;
